<template>
  <div>
    <div
      v-if="actions.length"
      class="actions"
    >
      <router-link
        v-for="action in actions"
        :key="`action-${action.id}`"
        class="actions__item config-btn"
        :to="{ name: 'ACTION', params: { id: action.id } }"
      >
        <div class="mb-3 h-24">
          <img
            class="h-24"
            :src="action.photo_url"
            :alt="action.name"
          >
        </div>
        {{ name(action) }}
      </router-link>
    </div>
    <div
      v-else
      class="actions__no-results"
    >
      {{ $t('team.noResults') }}
    </div>
  </div>
</template>
<script>
import name from '@/mixins/name';

export default {
  name: 'ActionList',
  mixins: [name],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 15px;
  @screen md {
    grid-template-columns: repeat(4, 1fr);
  }
  &__item {
    @apply py-18;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  &__title {
    @apply pb-8 text-lg text-primary font-semibold;
    grid-column: 1 / 2;
  }
  &__no-results {
    @apply pt-1 text-sm text-center;
  }
}
</style>
